export const colorMapping = {
	'--wst-color-fill-background-primary': 'color_11',
	'--wst-color-fill-background-secondary': 'color_12',
	'--wst-color-text-primary': 'color_15',
	'--wst-color-text-secondary': 'color_14',
	'--wst-color-action': 'color_18',
	'--wst-color-disabled': 'color_39',
	'--wst-color-title': 'color_45',
	'--wst-color-subtitle': 'color_46',
	'--wst-color-line': 'color_47',
	'--wst-button-color-fill-primary': 'color_48',
	'--wst-button-color-border-primary': 'color_49',
	'--wst-button-color-text-primary': 'color_50',
	'--wst-button-color-fill-primary-hover': 'color_51',
	'--wst-button-color-border-primary-hover': 'color_52',
	'--wst-button-color-text-primary-hover': 'color_53',
	'--wst-button-color-fill-primary-disabled': 'color_54',
	'--wst-button-color-border-primary-disabled': 'color_55',
	'--wst-button-color-text-primary-disabled': 'color_56',
	'--wst-button-color-fill-secondary': 'color_57',
	'--wst-button-color-border-secondary': 'color_58',
	'--wst-button-color-text-secondary': 'color_59',
	'--wst-button-color-fill-secondary-hover': 'color_60',
	'--wst-button-color-border-secondary-hover': 'color_61',
	'--wst-button-color-text-secondary-hover': 'color_62',
	'--wst-button-color-fill-secondary-disabled': 'color_63',
	'--wst-button-color-border-secondary-disabled': 'color_64',
	'--wst-button-color-text-secondary-disabled': 'color_65',
	'--wst-color-fill-base-1': 'color_36',
	'--wst-color-fill-base-2': 'color_37',
	'--wst-color-fill-base-shade-1': 'color_38',
	'--wst-color-fill-base-shade-2': 'color_39',
	'--wst-color-fill-base-shade-3': 'color_40',
	'--wst-color-fill-accent-1': 'color_41',
	'--wst-color-fill-accent-2': 'color_42',
	'--wst-color-fill-accent-3': 'color_43',
	'--wst-color-fill-accent-4': 'color_44',
}

export const fontMapping = {
	'--wst-font-style-h2': 'font_2',
	'--wst-font-style-h3': 'font_3',
	'--wst-font-style-h4': 'font_4',
	'--wst-font-style-h5': 'font_5',
	'--wst-font-style-h6': 'font_6',
	'--wst-font-style-body-large': 'font_7',
	'--wst-font-style-body-medium': 'font_8',
	'--wst-font-style-body-small': 'font_9',
	'--wst-font-style-body-x-small': 'font_10',
}

export const CUSTOM_ELEMENT_ALLOW_FOR_ALL_EXPERIMENT = 'specs.thunderbolt.allowCustomElementForAll'
export const CUSTOM_ELEMENT_GET_APP_TOKEN_EXPERIMENT = 'specs.thunderbolt.getAppTokenForCustomElement'
